export enum IconStyleEnum {
  LINE = 'line',
  FILL = 'fill',
}
